import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import SmsMessageList from '../components/SmsMessageList';
import {
  loadSmsMessages,
  createSmsMessage,
} from '../../../../../state/modules/smsMessages/actions';
import {
  claimSmsConversation,
  resolveSmsConversation,
  reopenSmsConversation,
  markAsReadSmsMessages,
} from '../../../../../state/modules/smsConversations/actions';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const profileId = state.session.get('profileId');
  const partnershipId = storage.get(findStorageType(), 'partnershipId');
  const smsConversationId = ownProps.selectedSmsConversation?.id;
  const limit = 20;
  const order = 'sent_at.desc';
  const page = 1;

  const result = state.smsMessages.getIn([
    'pages',
    partnershipId,
    smsConversationId,
    order,
    limit,
    page,
  ]);

  const updatedConversation = smsConversationId
    ? state.entities.getIn(['smsConversations', smsConversationId])
    : null;

  const tz = state.userAccount.getIn(
    ['data', 'timezone'],
    'America/Los_Angeles'
  );


  return {
    tz,
    list: result
      ? result
        .toArray()
        .map((x) => {
          const entity = state.entities.getIn(['smsMessages', x]);
          if (!entity) return null;

          return {
            key: x,
            ...denormalize(entity, schema.smsMessage, state.entities.toJS()),
          };
        })
        .filter((item) => item !== null && item.id)
        .reverse()
      : [],
    isLoading: state.smsMessages.get('isLoading'),
    total: state.smsMessages.get('total'),
    limit,
    order,
    partnershipId,
    profileId,
    smsConversationId,
    selectedSmsConversation: updatedConversation
      ? denormalize(
        updatedConversation,
        schema.smsConversation,
        state.entities.toJS()
      )
      : ownProps.selectedSmsConversation,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      partnershipId,
      smsConversationId,
      page,
      limit,
      order,
      filter,
      cb
    ) => {
      dispatch(
        loadSmsMessages(
          partnershipId,
          smsConversationId,
          page,
          limit,
          order,
          filter,
          cb
        )
      );
    },
    claim: (partnershipId, smsConversationId, data, cb) => {
      dispatch(
        claimSmsConversation(partnershipId, smsConversationId, data, cb)
      );
    },
    resolve: (partnershipId, smsConversationId, data, cb) => {
      dispatch(
        resolveSmsConversation(partnershipId, smsConversationId, data, cb)
      );
    },
    reopen: (partnershipId, smsConversationId, data, cb) => {
      dispatch(
        reopenSmsConversation(partnershipId, smsConversationId, data, cb)
      );
    },
    markAsRead: (partnershipId, smsConversationId, data, cb) => {
      dispatch(
        markAsReadSmsMessages(partnershipId, smsConversationId, data, cb)
      );
    },
    create: (partnershipId, smsConversationId, data, cb) => {
      dispatch(createSmsMessage(partnershipId, smsConversationId, data, cb));
    },
  };
};

const SmsMessageListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsMessageList);

export default SmsMessageListContainer;
